

import React, { Component } from "react";
import Slider from "react-slick";
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { Router, Link } from "routes";
import fontUniOrConvertZawgyi from '/utils/fontUniOrConvertZawgyi';
import Typography from '@material-ui/core/Typography';
import { createGlobalStyle } from "styled-components";
import VideoDuration from '/components/Video/VideoDuration';
import Head from 'next/head';
import CustomImage from '/components/customImage';

const StyleComponent = createGlobalStyle`
/* ************** start playlist slider *********** */
.playlist-slider .slick-slide {
  min-height: 210px;
}
.playlist-slider .slick-slide img {
  height: 79px;
  object-fit: cover;
  width: 100%;
}
.playlist-slider .nowPlaying{
  color: #fefefe;
  padding: 6px;
  position: absolute;
  line-height: 1;
  background-color: #e30000;
  opacity: .75;
  bottom: 0px;
  font-size: 14px;
}
.playlist-slider .nowPlayingHide{
  display: none;
}
.anchor-link{
    text-decoration: none;
}
.playlist-slider .slick-slider button.slick-arrow {
    min-height: 210px;
    height: 100%;
}
.playlist-slider .slick-slider button.slick-next {
    width: 25px;
    right: -30px;
}
.playlist-slider .slick-slider button.slick-prev {
    width: 25px;
    left: -30px;    
}
.playlist-slider .slick-next:before, .playlist-slider .slick-prev:before{
    color: #0A0A0A;
}

 /* ************** end playlist slider *********** */
`

const styles = (theme) => ({
    playlistCarouselItem: {
        width: "128px",
        padding: 6,
        '&:hover': {
            opacity: '1!important'
        }
    },

    wrapper: {
        fontFamily: ["SpaceGrotesk", "Padauk", "DuwunFont", "serif"],
        padding: '0 30px 0',
        position: 'relative',
        [theme.breakpoints.only('xs')]: {
            // padding: '14px 0px'
        }
    }
})

class PlaylistCarousel extends Component {
    constructor (props) {
        super(props)
        this.state = {
          clientXonMouseDown: null,
          clientYonMouseDown: null,
        }
    }
    handleOnMouseDown (e) {
        this.setState({
          clientXonMouseDown: e.clientX,
          clientYonMouseDown: e.clientY
        })
        e.preventDefault() // stops weird link dragging effect
      }

      handleOnClick (e, clickedIndex) {
        const { playlist, routeName, slickGoToProp } = this.props;
        slickGoToProp.slickGoTo(clickedIndex)
        if (this.state.clientXonMouseDown !== e.clientX ||
            this.state.clientYonMouseDown !== e.clientY) {
          e.preventDefault()
        }
        // Router.pushRoute(routeName, {id: slug, list: playlist.playlist_id})

      }

  render() {
    const { classes, playlistItems, routeName, routeParams, queryId, slider, data, playlist, isPlaylist, tagsParam, categoriesParam, perPage, isSectionPlaylistWidget, currentItem } = this.props;
    let initialIndex = playlistItems && playlistItems.length > 0 && playlistItems.findIndex((item, index) => item.slug === queryId);
    let settings = {
      dots: false,
      infinite: playlistItems && playlistItems.length > 1,
      autoplay: false,
      arrows: true,
      slidesToShow: 4,
      slidesToScroll: 1,
      swipeToSlide: true,
      // focusOnSelect: true,
      speed: 500,
      initialSlide: initialIndex,
      variableWidth: true,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        },
        {
            breakpoint: 360,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
        // You can unslick at a given breakpoint now by adding:
        // settings: "unslick"
        // instead of a settings object
      ]
    };
    const showAds = currentItem.no_ads ? false : true;
    return (
        <>
        <Head>
            <link href="https://fonts.googleapis.com/icon?family=Material+Icons" rel="stylesheet" />
        </Head>
        <StyleComponent />
        {
            showAds ? <div style={{ textAlign: 'center' }} id="video-ad-companion"></div> : null
        }
        {playlistItems &&
        <div className={classes.wrapper}>
            {
              isPlaylist && playlist.playlist_id && <div>{`${fontUniOrConvertZawgyi(playlist.title)} (${playlist.video_count} Videos)`}</div>
            }
            <div className="playlist-slider">
                <Slider ref={slider} {...settings}>
                    
                { playlistItems.length > 0 && playlistItems.map((item, index) => {
                    const catActive = queryId == item.slug
                    return(
                    <React.Fragment key={index}>
                    {/* <Link route={routeName} params={ isPlaylist && playlist.playlist_id  ? {id: playlist.playlist_id, videoId: item.slug} : {videoId: item.slug}}>   */}
                    <Link route={routeName} params={ isPlaylist && playlist.playlist_id  ? {id: playlist.playlist_id, videoId: item.slug} : isSectionPlaylistWidget ? {videoId: item.slug, perPage: perPage, categories: categoriesParam, tags: tagsParam } : {videoId: item.slug}}>
                        <a className="anchor-link"
                            onMouseDown={e => this.handleOnMouseDown(e)}
                            onClick={e => this.handleOnClick(e, index)}
                        >
                            <div className={classes.playlistCarouselItem} style={{ opacity: catActive ? 1 : 0.6 }}>
                                <div style={{ position: 'relative' }}>
                                    <CustomImage
                                      imgSrc={item.posters && item.posters.social ? item.posters.thumb_mobile : 'https://duwun-data.sgp1.cdn.digitaloceanspaces.com/react-assets/image/default-video-1000x500.png'}
                                      imgClass={classes.playlistCarouselImg}
                                    />
                                    {
                                        !catActive &&
                                        <div style={{ position: 'absolute', left: 70, }}>
                                        <span className="material-icons" style={{ position: 'absolute', bottom: 0, right: 42, bottom: 2, color:' #fff' }}>
                                            play_circle_outline
                                        </span>
                                        <VideoDuration vDuration={item.duration} />
                                        </div>
                                    }
                                    <div className={catActive ? 'nowPlaying' : 'nowPlayingHide'}>Now Playing</div>
                                </div>
                                <Typography component="p" style={{ padding: '10px 0px', fontFamily: ["SpaceGrotesk", "Padauk", "DuwunFont", "serif"], lineHeight: '22px', fontSize: 13, fontWeight: 600, overflowWrap: 'break-word' }}>
                                    {fontUniOrConvertZawgyi(item.title)}
                                </Typography>
                            </div>
                        </a>
                    </Link>
                    </React.Fragment>
                )})}
                </Slider>
            </div>
        </div>
  }
  </>
  );
  }
}

PlaylistCarousel.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(PlaylistCarousel);
